module.exports = __webpack_public_path__ + "static/team2-310f2109ea4b6ddb7463151bf6c1b6f4.jpg";